<template>
  <div id="app">
    <div class="print-container">
      <pdf-content
        key="print-container"
        :date_range="date_range"
        :key_name="key_name"
        :phone="phone"
        :id_number="id_number"
        :team_category="team_category"
        :loan_type="loan_type"
        :loanTypeOptions="loanTypeOptions"
        :report-list="reportList"
        :loading="loading"
      />
    </div>
    <b-modal id="modal-print" size="lg" title="" hide-footer>
      <pdf-content
        :key_name="key_name"
        :date_range="date_range"
        :phone="phone"
        :id_number="id_number"
        :team_category="team_category"
        :loan_type="loan_type"
        :loanTypeOptions="loanTypeOptions"
        :report-list="reportList"
        :loading="loading"
      />
      <div class="modal-footer d-flex justify-content-center">
        <button class="btn btn-primary" @click="downloadPdf">列印</button>
      </div>
    </b-modal>
    <div class="report-container">
      <div class="filter-form">
        <h2 class="report-title">報表 » 供報提示報表</h2>
        <div class="form-group">
          <label>篩選項目</label>
        </div>

        <div class="form-group">
          <b-button
            variant="secondary"
            :class="`mr-1 report-btn ${
              key_name == '即將到期(15天)' && !date_range.from && !date_range.to ? 'active' : ''
            }`"
            @click="refetchData(15, true)"
            >15天</b-button
          >
          <b-button
            variant="secondary"
            :class="`mr-1 report-btn ${
              key_name == '即將到期(7天)' && !date_range.from && !date_range.to ? 'active' : ''
            }`"
            @click="refetchData(7, true)"
            >7天</b-button
          >
          <b-button
            variant="secondary"
            :class="`mr-1 report-btn ${
              key_name == '逾期' && !date_range.from && !date_range.to ? 'active' : ''
            }`"
            @click="refetchData(0, true)"
            >逾期</b-button
          >
        </div>


        <div class="form-group">
          <label>供款日期</label>
          <div class="date-range">
            <input type="date" v-model="date_range.from" />
            <span>至</span>
            <input type="date" v-model="date_range.to" />
            <div class="date-controls">
              <div class="date-nav">
                <button class="nav-btn" @click="handleDateChange('年', 'left')">
                  <feather-icon icon="ChevronLeftIcon"></feather-icon>
                </button>
                <button class="period-btn" @click="setDateRange('年')">
                  年
                </button>
                <button
                  class="nav-btn"
                  @click="handleDateChange('年', 'right')"
                >
                  <feather-icon icon="ChevronRightIcon"></feather-icon>
                </button>
              </div>
              <div class="date-nav">
                <button class="nav-btn" @click="handleDateChange('月', 'left')">
                  <feather-icon icon="ChevronLeftIcon"></feather-icon>
                </button>
                <button class="period-btn" @click="setDateRange('月')">
                  月
                </button>
                <button
                  class="nav-btn"
                  @click="handleDateChange('月', 'right')"
                >
                  <feather-icon icon="ChevronRightIcon"></feather-icon>
                </button>
              </div>
              <div class="date-nav">
                <button class="nav-btn" @click="handleDateChange('日', 'left')">
                  <feather-icon icon="ChevronLeftIcon"></feather-icon>
                </button>
                <button class="period-btn" @click="setDateRange('日')">
                  日
                </button>
                <button
                  class="nav-btn"
                  @click="handleDateChange('日', 'right')"
                >
                  <feather-icon icon="ChevronRightIcon"></feather-icon>
                </button>
              </div>
              <div class="date-nav">
                <button class="nav-btn" @click="handleDateChange('週', 'left')">
                  <feather-icon icon="ChevronLeftIcon"></feather-icon>
                </button>
                <button class="period-btn" @click="setDateRange('週')">
                  週
                </button>
                <button
                  class="nav-btn"
                  @click="handleDateChange('週', 'right')"
                >
                  <feather-icon icon="ChevronRightIcon"></feather-icon>
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="form-group">
          <label>貸款類別</label>
          <select v-model="loan_type_id" class="form-select">
            <option selected value="">全部</option>
            <option
              v-for="option in loanTypeOptions"
              :key="option.id"
              :value="option.id"
            >
              {{ option.name }}
            </option>
          </select>
        </div>

        <div class="form-group">
          <label>團隊類別</label>
          <select v-model="team_category" class="form-select">
            <option selected value="">全部</option>
            <option
              v-for="(option, index) in teamCategoryOptions"
              :key="index + option"
              :value="option"
            >
              {{ option }}
            </option>
          </select>
        </div>

        <div class="form-group">
          <label>身份證號碼</label>
          <input type="text" v-model="id_number" class="form-control" />
        </div>
        <div class="form-group">
          <label>手機號碼</label>
          <input type="text" v-model="phone" class="form-control" />
        </div>

        <!-- <div class="form-group">
          <label>融資類別</label>
          <select class="form-select">
            <option selected value="">全部</option>
          </select>
        </div> -->

        <div class="form-actions">
          <button class="btn btn-primary" @click="handleModalPrint">
            報表
          </button>
          <button class="btn btn-default" @click="resetFilter">重設</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { BButton } from "bootstrap-vue";
import PdfContent from "./PdfContent";
import { ref, onUnmounted } from "@vue/composition-api";
import store from "@/store";
import axiosIns from "@/libs/axios";

export default {
  name: "app",

  data() {
    return {
      contentRendered: false,
      progress: 0,
      generatingPdf: false,
      pdfDownloaded: false,
    };
  },
  setup() {
    const reportList = ref([]);
    const reportData = ref({});
    const date_range = ref({
      from: "",
      to: "",
    });

    const loan_type_id = ref("");
    const id_number = ref("");
    const phone = ref("");
    const team_category = ref("");
    const key_name = ref("即將到期(15天)");

    const refetchData = (key, reset = false) => {
      var extend = 0;
      var overdue = 0;


      

      if (key == 15) {
        extend = 1;
        overdue = 0;
        key_name.value = "即將到期(15天)";
      } else if (key == 7) {
        extend = 0;
        overdue = 0;
        key_name.value = "即將到期(7天)";
      } else {
        extend = null;
        overdue = 1;
        key_name.value = "逾期";
      }

      if(date_range.value.from && !date_range.value.to){
        date_range.value.to = date_range.value.from;
      }else if(!date_range.value.from && date_range.value.to){
        date_range.value.from = date_range.value.to;
      }

      if(reset){
        date_range.value = {
          from: "",
          to: "",
        };
        return;
      }
      
      loading.value = true;
      axiosIns
        .get("/report/upcoming-payment-reminders", {
          params: {
            pay_date_from: date_range.value.from,
            pay_date_to: date_range.value.to,
            loan_type_id: loan_type_id.value,
            id_number: id_number.value,
            phone: phone.value,
            team_category: team_category.value,
            orderBy: "loan_date",
            sortDesc: 1,
            extend,
            overdue,
          },
        })
        .then((response) => {
          reportList.value = response.data.data;
          loading.value = false;
        })
        .catch((error) => {
          if (error.response.status === 404) {
            reportList.value = undefined;
          }
          loading.value = false;
        });
    };

    const loanTypeOptions = ref([]);
    const teamCategoryOptions = ref([]);
    const loading = ref(false);

    const refetchOption = () => {
      store
        .dispatch("app/fetchOptionList", {
          loan_type: true,
        })
        .then((response) => {
          loanTypeOptions.value = response.data.loan_types;
        });

      axiosIns.get("/team_categories").then((response) => {
        teamCategoryOptions.value = response.data.team_category;
      });
    };

    refetchOption();
    // refetchData();

    return {
      reportList,
      reportData,
      refetchData,
      loanTypeOptions,
      teamCategoryOptions,
      loan_type_id,
      id_number,
      phone,
      team_category,
      key_name,
      loading,
      date_range,
    };
  },
  mounted(){
    // 移除 this.setDateRange("年");
  },

  computed: {
    loan_type() {
      return this.loanTypeOptions.find(
        (option) => option.id === this.loan_type_id
      )?.name;
    },
  },

  methods: {
    downloadPdf() {
      // 设置默认文件名
      const defaultFileName = `供報提示報表_${new Date().toISOString().slice(0,10)}`;
      // 提示用户输入文件名
      // const fileName = window.prompt('請輸入文件名稱:', defaultFileName);
      
      // if (fileName) {
        // 设置打印时的文件名
        const style = document.createElement('style');
        style.innerHTML = `
          @page {
            margin: 0mm 10mm;
          }
          @media print {
            html, body {
              height: 100%;
            }
          }
        `;
        document.head.appendChild(style);
        
        window.document.title = defaultFileName;
        window.print();
        
        // 打印完成后恢复原标题
        setTimeout(() => {
          document.head.removeChild(style);
          window.document.title = 'X Data';
        }, 100);
      // }
    },

    handleDateChange(type, direction) {
      const { from, to } = this.date_range;
      let fromDate = new Date(from);
      let toDate = new Date(to);

      switch (type) {
        case "年":
          const yearChange = direction === "left" ? -1 : 1;
          fromDate.setFullYear(fromDate.getFullYear() + yearChange);
          toDate.setFullYear(toDate.getFullYear() + yearChange);
          break;

        case "月":
          const monthChange = direction === "left" ? -1 : 1;
          fromDate.setMonth(fromDate.getMonth() + monthChange);
          toDate.setMonth(toDate.getMonth() + monthChange);
          break;

        case "日":
          const dayChange = direction === "left" ? -1 : 1;
          fromDate.setDate(fromDate.getDate() + dayChange);
          toDate.setDate(toDate.getDate() + dayChange);
          break;

        case "週":
          const weekChange = direction === "left" ? -7 : 7;
          fromDate.setDate(fromDate.getDate() + weekChange);
          toDate.setDate(toDate.getDate() + weekChange);
          break;
      }

      // 更新日期範圍
      this.date_range = {
        from: this.formatDate(fromDate),
        to: this.formatDate(toDate),
      };
    },

    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },

    // 設置日期範圍
    setDateRange(type) {
      const today = new Date();
      let fromDate = new Date();
      let toDate = new Date();

      switch (type) {
        case "年":
          // 設置為當年的 1月1日 到 12月31日
          fromDate = new Date(today.getFullYear(), 0, 1);
          toDate = new Date(today.getFullYear(), 11, 31);
          break;

        case "月":
          // 設置為當月的 1日 到 月末
          fromDate = new Date(today.getFullYear(), today.getMonth(), 1);
          toDate = new Date(today.getFullYear(), today.getMonth() + 1, 0);
          break;

        case "日":
          // 設置為今天
          fromDate = today;
          toDate = today;
          break;

        case "週":
          // 設置為本週的週一到週日
          const day = today.getDay() || 7;
          fromDate = new Date(today.setDate(today.getDate() - day));
          toDate = new Date(today.setDate(today.getDate() + 6));
          break;
      }

      this.date_range = {
        from: this.formatDate(fromDate),
        to: this.formatDate(toDate),
      };
    },

    handleModalPrint() {
      this.reportList = []
      if (this.key_name == "即將到期(15天)") {
        this.refetchData(15);
      } else if (this.key_name == "即將到期(7天)") {
        this.refetchData(7);
      } else {
        this.refetchData(0);
      }
      this.$bvModal.show("modal-print");
    },

    resetFilter() {
      this.setDateRange("年");
      this.loan_type_id = "";
      this.id_number = "";
      this.phone = "";
      this.team_category = "";
      this.refetchData(15, true);
    },
  },

  components: {
    PdfContent,
    BButton,
  },
};
</script>
<style lang="scss" scoped>
.report-wrapper .report-table tfoot th {
  width: 90px;
}
</style>
